/**
 * Favorites — общий модуль избранных тикеров (сквозной для /fa и /setups).
 *
 * Data-слой ИДЕНТИЧЕН реализации на /fa (web_app.py inline):
 *   - anon: localStorage 'fa.favorites'
 *   - auth: /api/favorites (GET) + /api/favorites/toggle + /api/favorites/sync
 * → добавление в избранное на одной странице видно на другой (сквозное).
 *
 * /fa пока использует свой inline-код (тот же data-слой). Этот модуль — для
 * /setups и любых будущих страниц; при желании /fa можно мигрировать на него.
 *
 * Usage (на странице):
 *   Favorites.init({ isAnon: true, onChange: function(ticker){ ... } });
 *   // после /api/auth/status:
 *   Favorites.setAuth(authState.is_anon); Favorites.load();
 *   // в рендере карточек/строк/шапки графика:
 *   html += Favorites.heartHtml(ticker);   // <button class="fav-heart" data-ticker=…>
 *   // после ре-рендера DOM:
 *   Favorites.refreshHearts(rootEl);       // обновить filled/outline по текущему состоянию
 *
 * Клик по .fav-heart перехватывается делегированно (capture-фаза) — не нужно
 * вешать onclick на каждую кнопку, и клик не «протекает» в карточку/строку.
 */
(function () {
  'use strict';

  var LOCAL_KEY = 'fa.favorites';
  var LIMIT = 200;

  var _favorites = [];
  var _loaded = false;
  var _isAnon = true;
  var _onChange = null;
  var _onAnonClick = null;  // опц. хук: anon-клик по сердечку (попап регистрации)
  var _csrf = null;   // токен или функция-геттер (страница может тянуть его async)

  // Заголовки POST: Content-Type + X-CSRF-Token (csrf_check в web_app.py требует
  // его на всех POST; страница, не монки-патчащая fetch, передаёт токен в init).
  function _postHeaders() {
    var h = { 'Content-Type': 'application/json' };
    var tok = (typeof _csrf === 'function') ? _csrf() : _csrf;
    if (tok) h['X-CSRF-Token'] = tok;
    return h;
  }

  // Тот же path, что у сердечка на /fa (viewBox 0 0 24 22).
  var _PATH = 'M12 21s-7.5-4.5-9.5-9.5C1.2 7.6 4 4 7.5 4c2.1 0 3.5 1.3 4.5 2.6C13 5.3 14.4 4 16.5 4 20 4 22.8 7.6 21.5 11.5 19.5 16.5 12 21 12 21z';
  var _SVG_OUTLINE = '<svg viewBox="0 0 24 22" fill="none" stroke="currentColor" stroke-width="2" '
    + 'stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" class="fav-outline">'
    + '<path d="' + _PATH + '"/></svg>';
  var _SVG_FILLED = '<svg viewBox="0 0 24 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg" '
    + 'class="fav-filled" style="display:none"><path d="' + _PATH + '"/></svg>';

  function _readLocal() {
    try { var r = localStorage.getItem(LOCAL_KEY); return r ? JSON.parse(r) : []; }
    catch (e) { return []; }
  }
  function _writeLocal(list) {
    try { localStorage.setItem(LOCAL_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isFavorite(t) { return _favorites.indexOf(t) >= 0; }
  function getFavorites() { return _favorites.slice(); }
  function isLoaded() { return _loaded; }

  function _emit(changed) {
    refreshHearts(document);
    if (typeof _onChange === 'function') { try { _onChange(changed); } catch (e) {} }
  }

  function setAuth(isAnon) { _isAnon = !!isAnon; }

  function load() {
    if (!_isAnon) {
      // Auth: если в localStorage что-то осталось (анон до логина) — синкаем
      // union на сервер, иначе просто читаем сервер.
      var localList = _readLocal();
      if (localList.length > 0) {
        fetch('/api/favorites/sync', {
          method: 'POST', headers: _postHeaders(),
          body: JSON.stringify({ tickers: localList })
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.ok) { _favorites = d.tickers || []; _writeLocal([]); _loaded = true; _emit(); }
        }).catch(function () {});
      } else {
        fetch('/api/favorites').then(function (r) { return r.json(); }).then(function (d) {
          if (d.tickers) { _favorites = d.tickers; _loaded = true; _emit(); }
        }).catch(function () {});
      }
    } else {
      _favorites = _readLocal();
      _loaded = true;
      _emit();
    }
  }

  function toggle(ev, ticker) {
    if (ev) {
      if (ev.stopPropagation) ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      if (ev.preventDefault) ev.preventDefault();
    }
    if (!ticker) return;
    // Anon-гейт (опциональный, per-page): если страница задала onAnonClick —
    // анонимный клик не пишет в localStorage, а вызывает хук (попап регистрации
    // на /setups). Без хука — старое поведение (локальное избранное на /fa).
    if (_isAnon && typeof _onAnonClick === 'function') {
      _onAnonClick(ev, ticker);
      return;
    }
    var willBe = !isFavorite(ticker);
    if (!_isAnon) {
      fetch('/api/favorites/toggle', {
        method: 'POST', headers: _postHeaders(),
        body: JSON.stringify({ ticker: ticker })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d.ok) {
          if (d.favorite) { if (!isFavorite(ticker)) _favorites.unshift(ticker); }
          else { _favorites = _favorites.filter(function (t) { return t !== ticker; }); }
          _emit(ticker); _toast(ev, d.favorite);
        } else { _toast(ev, false, d.error || 'Ошибка'); }
      }).catch(function () { _toast(ev, false, 'Ошибка сети'); });
    } else {
      if (willBe) {
        if (_favorites.length >= LIMIT) { _toast(ev, false, 'Лимит ' + LIMIT); return; }
        _favorites.unshift(ticker);
      } else {
        _favorites = _favorites.filter(function (t) { return t !== ticker; });
      }
      _writeLocal(_favorites);
      _emit(ticker); _toast(ev, willBe);
    }
  }

  /** HTML кнопки-сердечка. data-ticker несёт тикер, состояние — класс is-fav. */
  function heartHtml(ticker) {
    var fav = isFavorite(ticker);
    return '<button class="fav-heart' + (fav ? ' is-fav' : '') + '" type="button" '
      + 'data-ticker="' + ticker + '" data-fav="' + (fav ? 1 : 0) + '" '
      + 'aria-pressed="' + (fav ? 'true' : 'false') + '" '
      + 'title="' + (fav ? 'Убрать из watchlist' : 'Добавить этот тикер в watchlist') + '">'
      + _SVG_OUTLINE + _SVG_FILLED + '</button>';
  }

  /** Точечно обновить состояние всех .fav-heart[data-ticker] в root. */
  function refreshHearts(root) {
    root = root || document;
    var els = root.querySelectorAll('.fav-heart[data-ticker]');
    Array.prototype.forEach.call(els, function (el) {
      var tk = el.getAttribute('data-ticker');
      if (!tk) return;
      var fav = isFavorite(tk);
      el.classList.toggle('is-fav', fav);
      el.setAttribute('data-fav', fav ? 1 : 0);
      el.setAttribute('aria-pressed', fav ? 'true' : 'false');
      el.setAttribute('title', fav ? 'Убрать из watchlist' : 'Добавить этот тикер в watchlist');
    });
  }

  function _toast(ev, added, errMsg) {
    var old = document.querySelectorAll('.fav-toast');
    Array.prototype.forEach.call(old, function (t) { t.remove(); });
    var msg = errMsg || (added ? 'Добавлено в watchlist' : 'Убрано из watchlist');
    var toast = document.createElement('div');
    toast.className = 'fav-toast' + (errMsg ? ' err' : '');
    toast.textContent = msg;
    document.body.appendChild(toast);
    var x = null, y = null;
    if (ev && (typeof ev.clientX === 'number') && ev.clientX > 0) { x = ev.clientX; y = ev.clientY; }
    else if (ev && ev.target && ev.target.getBoundingClientRect) {
      var r = ev.target.getBoundingClientRect(); x = r.right; y = r.top + r.height / 2;
    }
    if (x !== null) { toast.style.left = (x + 10) + 'px'; toast.style.top = (y - 12) + 'px'; }
    else { toast.style.left = '50%'; toast.style.top = '50%'; toast.style.transform = 'translate(-50%,-50%)'; }
    setTimeout(function () {
      var tr = toast.getBoundingClientRect();
      if (tr.right > window.innerWidth - 8) { toast.style.left = (window.innerWidth - tr.width - 12) + 'px'; }
    }, 0);
    setTimeout(function () { toast.classList.add('out'); }, 1500);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 2050);
  }

  function init(opts) {
    opts = opts || {};
    if (typeof opts.isAnon === 'boolean') _isAnon = opts.isAnon;
    if (typeof opts.onChange === 'function') _onChange = opts.onChange;
    if (typeof opts.onAnonClick === 'function') _onAnonClick = opts.onAnonClick;
    if (opts.csrfToken !== undefined) _csrf = opts.csrfToken;  // токен или геттер
    // Делегированный click в CAPTURE-фазе — опережает click карточки/строки и
    // toggle() гасит дальнейшее распространение (stopImmediatePropagation).
    if (!document.body.getAttribute('data-fav-bound')) {
      document.body.setAttribute('data-fav-bound', '1');
      document.addEventListener('click', function (e) {
        var h = (e.target && e.target.closest) ? e.target.closest('.fav-heart') : null;
        if (!h) return;
        var tk = h.getAttribute('data-ticker');
        if (tk) toggle(e, tk);
      }, true);
    }
    if (opts.autoLoad !== false) load();
  }

  window.Favorites = {
    init: init, load: load, setAuth: setAuth,
    isFavorite: isFavorite, getFavorites: getFavorites, isLoaded: isLoaded,
    toggle: toggle, heartHtml: heartHtml, refreshHearts: refreshHearts,
  };
})();
